// extracted by mini-css-extract-plugin
export default {"root":"ButtonBase_root__tEGL-","disabled":"ButtonBase_disabled__8aw2c"};